// TxtMyCar Logo Component
// icon=true  → just the hexagon badge (for sidebar)
// icon=false → full wordmark with .co.uk (for auth pages)

export function LogoIcon({ size = 56 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160" width={size} height={size}>
      <polygon points="80,6 146,43 146,117 80,154 14,117 14,43" fill="#FFD93D"/>
      {/* Car body */}
      <rect x="30" y="96" width="100" height="34" rx="8" fill="#1a1a24"/>
      {/* Car roof */}
      <path d="M43 96 L57 68 L103 68 L117 96 Z" fill="#1a1a24"/>
      {/* Windows */}
      <path d="M53 93 L63 73 L97 73 L107 93 Z" fill="#FFD93D" opacity="0.35"/>
      {/* Wheels */}
      <circle cx="52" cy="132" r="12" fill="#1a1a24" stroke="#FFD93D" strokeWidth="3.5"/>
      <circle cx="108" cy="132" r="12" fill="#1a1a24" stroke="#FFD93D" strokeWidth="3.5"/>
      {/* Headlight */}
      <rect x="128" y="100" width="8" height="8" rx="2" fill="white"/>
      {/* Speech bubble */}
      <rect x="82" y="34" width="46" height="32" rx="7" fill="#1a1a24"/>
      <polygon points="89,66 101,66 89,78" fill="#1a1a24"/>
      <rect x="90" y="42" width="30" height="4" rx="2" fill="#FFD93D"/>
      <rect x="90" y="51" width="22" height="4" rx="2" fill="#FFD93D" opacity="0.6"/>
      <rect x="90" y="60" width="26" height="4" rx="2" fill="#FFD93D" opacity="0.35"/>
    </svg>
  );
}

export function LogoFull({ iconSize = 72 }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
      <LogoIcon size={iconSize} />
      <div style={{ textAlign: 'center', lineHeight: 1.1 }}>
        <div style={{
          fontFamily: "'Arial Black', 'Arial Bold', Arial, sans-serif",
          fontWeight: 900,
          fontSize: 36,
          color: '#FFD93D',
          letterSpacing: -1,
        }}>TxtMyCar</div>
        <div style={{
          fontFamily: "'Arial Black', 'Arial Bold', Arial, sans-serif",
          fontWeight: 900,
          fontSize: 16,
          color: '#FFD93D',
          opacity: 0.65,
          letterSpacing: 2,
          marginTop: 2,
        }}>.co.uk</div>
      </div>
    </div>
  );
}
